import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 12l-6 6V6l6 6z" }));
export default createSvgIcon(iconPath, "ArrowFillRight");
//# sourceMappingURL=ArrowFillRightIcon.js.map